import React, { useContext } from 'react';
import { AnimatePresence } from 'framer-motion';
import { ToasterSystemContext } from '../toasterSystem';
import { Toaster } from '../toaster';
import S from './style/styled';
export var ToasterGroup = function ToasterGroup() {
  var _useContext = useContext(ToasterSystemContext),
      toastGroup = _useContext.toastGroup,
      removeToast = _useContext.removeToast;

  return React.createElement(AnimatePresence, null, React.createElement(S.ToasterGroup, null, toastGroup.map(function (_ref) {
    var type = _ref.type,
        text = _ref.text,
        id = _ref.id;
    return React.createElement(Toaster, {
      isVisible: true,
      type: type,
      text: text,
      key: id,
      onClick: function onClick() {
        return removeToast(id);
      }
    });
  })));
};